import React, { useEffect } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { connect } from 'react-redux';
import { reset } from '@/slices/messageSARSlice';
import NoData from '@/components/NoData';
import Header from './Header';
import Send from './Send';
import Receive from './Receive';

function MessageSendReceive({ clientHeight, reset, currentTopic }) {
  useEffect(() => {
    return () => {
      reset();
    };
  }, [reset]);

  return (
    <Root $clientHeight={clientHeight}>
      <Title>消息收发</Title>
      <Header />
      {currentTopic ? (
        <Body>
          <Send />
          <Receive />
        </Body>
      ) : (
        <NoData style={{ height: '100%' }} tip={'请先创建Topic'} />
      )}
      <GlobalStyle />
    </Root>
  );
}

export default connect(
  (state) => ({
    clientWidth: state.layout.clientWidth,
    clientHeight: state.layout.clientHeight,
    currentTopic: state.messageSAR.currentTopic,
  }),
  {
    reset,
  },
)(MessageSendReceive);

const Root = styled.div`
  height: ${(props) => props.$clientHeight - 106}px;
  display: flex;
  flex-direction: column;
  .t-breadcrumb {
    display: none;
  }
`;

const Title = styled.div`
  font-size: 22px;
  font-weight: 600;
`;

const Body = styled.div`
  padding: 0 20px 0 0;
  flex: 1;
  display: flex;
  box-sizing: border-box;
  min-height: 0;
  column-gap: 20px;
`;

const GlobalStyle = createGlobalStyle`
  .t-breadcrumb {
    display: none;
  }
  .body-container {
    &&& {
      margin-top: 0;
    }
  }
`;
